import { render, staticRenderFns } from "./Classificacoes.vue?vue&type=template&id=6aeb04d5"
import script from "./Classificacoes.vue?vue&type=script&lang=js"
export * from "./Classificacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports